// Назви на українському (основна аудиторія — Україна, скрапер берe
// оголошення з olx.ua / ria.com). Спершу великі міста, потім обласні
// «глибинки» з активністю на OLX. Молдавські міста прибрано (спадок
// старої географії) — ринок легкових тільки Україна.
export const cities = [
    { name: 'Київ', region: 'Київська область', lat: 50.4501, lng: 30.5234 },
    { name: 'Харків', region: 'Харківська область', lat: 49.9935, lng: 36.2304 },
    { name: 'Одеса', region: 'Одеська область', lat: 46.4825, lng: 30.7233 },
    { name: 'Дніпро', region: 'Дніпропетровська область', lat: 48.4647, lng: 35.0462 },
    { name: 'Донецьк', region: 'Донецька область', lat: 48.0159, lng: 37.8028 },
    { name: 'Запоріжжя', region: 'Запорізька область', lat: 47.8388, lng: 35.1396 },
    { name: 'Львів', region: 'Львівська область', lat: 49.8397, lng: 24.0297 },
    { name: 'Кривий Ріг', region: 'Дніпропетровська область', lat: 47.9095, lng: 33.3814 },
    { name: 'Миколаїв', region: 'Миколаївська область', lat: 46.9659, lng: 32.0038 },
    { name: 'Маріуполь', region: 'Донецька область', lat: 47.0951, lng: 37.5493 },
    { name: 'Вінниця', region: 'Вінницька область', lat: 49.2331, lng: 28.4682 },
    { name: 'Полтава', region: 'Полтавська область', lat: 49.5937, lng: 34.5407 },
    { name: 'Чернігів', region: 'Чернігівська область', lat: 51.4982, lng: 31.2893 },
    { name: 'Черкаси', region: 'Черкаська область', lat: 49.4444, lng: 32.0598 },
    { name: 'Житомир', region: 'Житомирська область', lat: 50.2547, lng: 28.6587 },
    { name: 'Суми', region: 'Сумська область', lat: 50.9077, lng: 34.7981 },
    { name: 'Рівне', region: 'Рівненська область', lat: 50.6199, lng: 26.2516 },
    { name: 'Івано-Франківськ', region: 'Івано-Франківська область', lat: 48.9226, lng: 24.7111 },
    { name: 'Тернопіль', region: 'Тернопільська область', lat: 49.5535, lng: 25.5948 },
    { name: 'Ужгород', region: 'Закарпатська область', lat: 48.6208, lng: 22.2879 },
    { name: 'Чернівці', region: 'Чернівецька область', lat: 48.2915, lng: 25.9402 },
    { name: 'Хмельницький', region: 'Хмельницька область', lat: 49.4216, lng: 26.9965 },
    { name: 'Херсон', region: 'Херсонська область', lat: 46.6354, lng: 32.6169 },
    { name: 'Луцьк', region: 'Волинська область', lat: 50.7472, lng: 25.3254 },
    { name: 'Кропивницький', region: 'Кіровоградська область', lat: 48.5132, lng: 32.2597 },
    { name: 'Кам’янське', region: 'Дніпропетровська область', lat: 48.5159, lng: 34.6074 },
    { name: 'Бровари', region: 'Київська область', lat: 50.5114, lng: 30.7934 },
    { name: 'Ірпінь', region: 'Київська область', lat: 50.5216, lng: 30.2468 },
    { name: 'Буча', region: 'Київська область', lat: 50.5382, lng: 30.2122 },
    { name: 'Біла Церква', region: 'Київська область', lat: 49.8031, lng: 30.1203 },
    { name: 'Умань', region: 'Черкаська область', lat: 48.7462, lng: 30.2223 },
    { name: 'Мукачево', region: 'Закарпатська область', lat: 48.4414, lng: 22.7162 },
    { name: 'Бориспіль', region: 'Київська область', lat: 50.3511, lng: 30.9549 },
    { name: 'Кам’янець-Подільський', region: 'Хмельницька область', lat: 48.685, lng: 26.5853 },
    { name: 'Дрогобич', region: 'Львівська область', lat: 49.3486, lng: 23.5111 },
    { name: 'Ялта', region: 'АР Крим', lat: 44.5024, lng: 34.1662 },
    { name: 'Севастополь', region: 'АР Крим', lat: 44.6167, lng: 33.525 },
    { name: 'Сімферополь', region: 'АР Крим', lat: 44.9521, lng: 34.1024 },
    // Донеччина / Луганщина
    { name: 'Краматорськ', region: 'Донецька область', lat: 48.7392, lng: 37.5847 },
    { name: 'Слов’янськ', region: 'Донецька область', lat: 48.85, lng: 37.6 },
    { name: 'Покровськ', region: 'Донецька область', lat: 48.2822, lng: 37.1836 },
    { name: 'Бахмут', region: 'Донецька область', lat: 48.5956, lng: 38.0233 },
    { name: 'Лиман', region: 'Донецька область', lat: 49.0, lng: 37.8 },
    { name: 'Костянтинівка', region: 'Донецька область', lat: 48.5286, lng: 37.715 },
    { name: 'Дружківка', region: 'Донецька область', lat: 48.6167, lng: 37.55 },
    { name: 'Макіївка', region: 'Донецька область', lat: 48.0478, lng: 37.9256 },
    { name: 'Горлівка', region: 'Донецька область', lat: 48.3336, lng: 38.0508 },
    { name: 'Єнакієве', region: 'Донецька область', lat: 48.2292, lng: 38.2042 },
    { name: 'Сєверодонецьк', region: 'Луганська область', lat: 48.9431, lng: 38.4936 },
    { name: 'Лисичанськ', region: 'Луганська область', lat: 48.9453, lng: 38.2786 },
    { name: 'Луганськ', region: 'Луганська область', lat: 48.574, lng: 39.3078 },
    { name: 'Алчевськ', region: 'Луганська область', lat: 48.4333, lng: 38.9667 },
    // Дніпропетровщина
    { name: 'Нікополь', region: 'Дніпропетровська область', lat: 47.5711, lng: 34.3972 },
    { name: 'Павлоград', region: 'Дніпропетровська область', lat: 48.5167, lng: 35.8667 },
    { name: 'Жовті Води', region: 'Дніпропетровська область', lat: 48.0333, lng: 33.5 },
    { name: 'Синельникове', region: 'Дніпропетровська область', lat: 48.6333, lng: 35.5167 },
    // Запоріжжя
    { name: 'Мелітополь', region: 'Запорізька область', lat: 46.8489, lng: 35.3678 },
    { name: 'Бердянськ', region: 'Запорізька область', lat: 46.7549, lng: 36.7892 },
    { name: 'Енергодар', region: 'Запорізька область', lat: 47.4833, lng: 34.65 },
    { name: 'Токмак', region: 'Запорізька область', lat: 47.25, lng: 35.7167 },
    { name: 'Пологи', region: 'Запорізька область', lat: 47.4667, lng: 36.25 },
    // Харківщина
    { name: 'Лозова', region: 'Харківська область', lat: 49.8833, lng: 36.3 },
    { name: 'Ізюм', region: 'Харківська область', lat: 49.2106, lng: 37.2833 },
    { name: 'Чугуїв', region: 'Харківська область', lat: 49.8333, lng: 36.6833 },
    { name: 'Куп’янськ', region: 'Харківська область', lat: 49.7111, lng: 37.6167 },
    // Полтавщина
    { name: 'Кременчук', region: 'Полтавська область', lat: 49.0678, lng: 33.4167 },
    { name: 'Миргород', region: 'Полтавська область', lat: 49.9667, lng: 33.6167 },
    { name: 'Лубни', region: 'Полтавська область', lat: 50.0167, lng: 32.9936 },
    // Кіровоградщина
    { name: 'Олександрія', region: 'Кіровоградська область', lat: 48.6667, lng: 33.3167 },
    // Черкащина
    { name: 'Сміла', region: 'Черкаська область', lat: 49.1667, lng: 31.8833 },
    { name: 'Золотоніша', region: 'Черкаська область', lat: 49.0333, lng: 32.0333 },
    { name: 'Канів', region: 'Черкаська область', lat: 49.75, lng: 31.4667 },
    // Київщина
    { name: 'Фастів', region: 'Київська область', lat: 50.08, lng: 29.9181 },
    { name: 'Васильків', region: 'Київська область', lat: 50.1836, lng: 30.3172 },
    { name: 'Обухів', region: 'Київська область', lat: 50.1153, lng: 30.6281 },
    { name: 'Боярка', region: 'Київська область', lat: 50.3292, lng: 30.2969 },
    { name: 'Вишневе', region: 'Київська область', lat: 50.3864, lng: 30.3744 },
    { name: 'Яготин', region: 'Київська область', lat: 50.25, lng: 31.8167 },
    // Житомирщина
    { name: 'Бердичів', region: 'Житомирська область', lat: 49.9, lng: 28.5833 },
    { name: 'Коростень', region: 'Житомирська область', lat: 50.9583, lng: 28.6467 },
    { name: 'Звягель', region: 'Житомирська область', lat: 50.5864, lng: 27.6269 },
    { name: 'Малин', region: 'Житомирська область', lat: 51.3, lng: 29.2333 },
    // Вінниччина
    { name: 'Жмеринка', region: 'Вінницька область', lat: 49.0333, lng: 28.2 },
    { name: 'Могилів-Подільський', region: 'Вінницька область', lat: 48.4467, lng: 27.7986 },
    { name: 'Хмільник', region: 'Вінницька область', lat: 49.55, lng: 27.9833 },
    { name: 'Ладижин', region: 'Вінницька область', lat: 48.1681, lng: 29.2403 },
    { name: 'Козятин', region: 'Вінницька область', lat: 49.7, lng: 28.8333 },
    // Хмельниччина
    { name: 'Старокостянтинів', region: 'Хмельницька область', lat: 49.75, lng: 27.2 },
    { name: 'Шепетівка', region: 'Хмельницька область', lat: 50.1833, lng: 27.05 },
    { name: 'Нетішин', region: 'Хмельницька область', lat: 50.3333, lng: 26.6333 },
    // Тернопілля
    { name: 'Чортків', region: 'Тернопільська область', lat: 49.0167, lng: 25.8 },
    { name: 'Кременець', region: 'Тернопільська область', lat: 50.1, lng: 25.7167 },
    // Прикарпаття
    { name: 'Калуш', region: 'Івано-Франківська область', lat: 49.0286, lng: 24.3644 },
    { name: 'Коломия', region: 'Івано-Франківська область', lat: 48.5292, lng: 25.0358 },
    { name: 'Яремче', region: 'Івано-Франківська область', lat: 48.4231, lng: 24.5494 },
    { name: 'Надвірна', region: 'Івано-Франківська область', lat: 48.6333, lng: 24.5833 },
    // Львівщина
    { name: 'Стрий', region: 'Львівська область', lat: 49.2667, lng: 23.85 },
    { name: 'Трускавець', region: 'Львівська область', lat: 49.2833, lng: 23.5 },
    { name: 'Самбір', region: 'Львівська область', lat: 49.5167, lng: 23.2 },
    { name: 'Борислав', region: 'Львівська область', lat: 49.2833, lng: 23.4167 },
    { name: 'Шептицький', region: 'Львівська область', lat: 50.3833, lng: 24.2333 },
    { name: 'Городок', region: 'Львівська область', lat: 49.7833, lng: 23.65 },
    { name: 'Яворів', region: 'Львівська область', lat: 49.9333, lng: 23.4 },
    { name: 'Броди', region: 'Львівська область', lat: 50.0833, lng: 25.15 },
    { name: 'Золочів', region: 'Львівська область', lat: 49.8069, lng: 24.9 },
    // Рівненщина
    { name: 'Дубно', region: 'Рівненська область', lat: 50.4167, lng: 25.75 },
    { name: 'Сарни', region: 'Рівненська область', lat: 51.3333, lng: 26.6 },
    // Волинь
    { name: 'Володимир', region: 'Волинська область', lat: 50.85, lng: 24.3167 },
    { name: 'Ковель', region: 'Волинська область', lat: 51.2167, lng: 24.7167 },
    // Закарпаття
    { name: 'Хуст', region: 'Закарпатська область', lat: 48.1833, lng: 23.3 },
    { name: 'Виноградів', region: 'Закарпатська область', lat: 47.95, lng: 23.0333 },
    { name: 'Тячів', region: 'Закарпатська область', lat: 47.9333, lng: 23.5667 },
    { name: 'Рахів', region: 'Закарпатська область', lat: 48.0533, lng: 24.2 },
    { name: 'Берегове', region: 'Закарпатська область', lat: 48.2, lng: 22.6333 },
    // Буковина
    { name: 'Хотин', region: 'Чернівецька область', lat: 48.5097, lng: 26.4958 },
    { name: 'Сторожинець', region: 'Чернівецька область', lat: 48.1667, lng: 25.7167 },
    // Одещина
    { name: 'Ізмаїл', region: 'Одеська область', lat: 45.35, lng: 28.85 },
    { name: 'Білгород-Дністровський', region: 'Одеська область', lat: 46.1833, lng: 30.35 },
    { name: 'Чорноморськ', region: 'Одеська область', lat: 46.3, lng: 30.65 },
    { name: 'Південне', region: 'Одеська область', lat: 46.05, lng: 30.7 },
    { name: 'Подільськ', region: 'Одеська область', lat: 47.7333, lng: 29.55 },
    { name: 'Арциз', region: 'Одеська область', lat: 45.85, lng: 29.4333 },
    { name: 'Болград', region: 'Одеська область', lat: 45.6833, lng: 28.6 },
    // Миколаївщина
    { name: 'Первомайськ', region: 'Миколаївська область', lat: 48.0333, lng: 30.85 },
    { name: 'Вознесенськ', region: 'Миколаївська область', lat: 47.5667, lng: 31.3667 },
    { name: 'Южноукраїнськ', region: 'Миколаївська область', lat: 47.8167, lng: 31.1833 },
    { name: 'Очаків', region: 'Миколаївська область', lat: 46.6167, lng: 31.55 },
    // Херсонщина
    { name: 'Нова Каховка', region: 'Херсонська область', lat: 46.75, lng: 33.3667 },
    { name: 'Скадовськ', region: 'Херсонська область', lat: 46.1167, lng: 32.9167 },
    { name: 'Гола Пристань', region: 'Херсонська область', lat: 46.55, lng: 32.5 },
    { name: 'Берислав', region: 'Херсонська область', lat: 46.8333, lng: 33.5 },
    // Сумщина
    { name: 'Конотоп', region: 'Сумська область', lat: 51.2, lng: 28.1333 },
    { name: 'Шостка', region: 'Сумська область', lat: 51.85, lng: 33.4833 },
    { name: 'Охтирка', region: 'Сумська область', lat: 50.3, lng: 34.9 },
    { name: 'Ромни', region: 'Сумська область', lat: 50.75, lng: 33.4667 },
    { name: 'Глухів', region: 'Сумська область', lat: 51.6833, lng: 33.9167 },
    // Чернігівщина
    { name: 'Ніжин', region: 'Чернігівська область', lat: 51.05, lng: 31.8833 },
    { name: 'Прилуки', region: 'Чернігівська область', lat: 50.5936, lng: 32.3897 },
    // Крим
    { name: 'Керч', region: 'АР Крим', lat: 45.35, lng: 36.4667 },
    { name: 'Феодосія', region: 'АР Крим', lat: 45.0333, lng: 35.3833 },
    { name: 'Євпаторія', region: 'АР Крим', lat: 45.1936, lng: 33.3647 },
    { name: 'Джанкой', region: 'АР Крим', lat: 45.7083, lng: 34.3922 },
];
/** Ключ пошуку: нижній регістр, без апострофів (’/'/ʼ) і «ё», одинарні пробіли. */
function cityKey(name) {
    return name
        .trim()
        .toLowerCase()
        .replace(/ё/g, 'е')
        .replace(/[’'`ʼ]/g, '')
        .replace(/\s+/g, ' ');
}
// Російські написання та історичні назви → канонічна українська назва.
// Ключі БЕЗ апострофів (див. cityKey).
const cityAliases = {
    киев: 'Київ',
    харьков: 'Харків',
    одесса: 'Одеса',
    днепр: 'Дніпро',
    днепропетровск: 'Дніпро',
    дніпропетровськ: 'Дніпро',
    донецк: 'Донецьк',
    запорожье: 'Запоріжжя',
    львов: 'Львів',
    'кривой рог': 'Кривий Ріг',
    николаев: 'Миколаїв',
    мариуполь: 'Маріуполь',
    винница: 'Вінниця',
    чернигов: 'Чернігів',
    черкассы: 'Черкаси',
    ровно: 'Рівне',
    'ивано-франковск': 'Івано-Франківськ',
    тернополь: 'Тернопіль',
    унгвар: 'Ужгород',
    черновцы: 'Чернівці',
    хмельницкий: 'Хмельницький',
    луцк: 'Луцьк',
    кировоград: 'Кропивницький',
    кіровоград: 'Кропивницький',
    каменское: 'Кам’янське',
    днепродзержинск: 'Кам’янське',
    дніпродзержинськ: 'Кам’янське',
    бровары: 'Бровари',
    ирпень: 'Ірпінь',
    'белая церковь': 'Біла Церква',
    борисполь: 'Бориспіль',
    'каменец-подольский': 'Кам’янець-Подільський',
    дрогобыч: 'Дрогобич',
    // Донеччина / Луганщина
    краматорск: 'Краматорськ',
    славянск: 'Слов’янськ',
    покровск: 'Покровськ',
    красноармейск: 'Покровськ',
    артемовск: 'Бахмут',
    артемівськ: 'Бахмут',
    'красный лиман': 'Лиман',
    константиновка: 'Костянтинівка',
    дружковка: 'Дружківка',
    макеевка: 'Макіївка',
    горловка: 'Горлівка',
    енакиево: 'Єнакієве',
    северодонецк: 'Сєверодонецьк',
    лисичанск: 'Лисичанськ',
    луганск: 'Луганськ',
    алчевск: 'Алчевськ',
    // Дніпропетровщина
    никополь: 'Нікополь',
    'желтые воды': 'Жовті Води',
    синельниково: 'Синельникове',
    // Запоріжжя
    мелитополь: 'Мелітополь',
    бердянск: 'Бердянськ',
    энергодар: 'Енергодар',
    // Харківщина
    лозовая: 'Лозова',
    изюм: 'Ізюм',
    чугуев: 'Чугуїв',
    купянск: 'Куп’янськ',
    // Полтавщина
    кременчуг: 'Кременчук',
    // Кіровоградщина
    александрия: 'Олександрія',
    // Черкащина
    смела: 'Сміла',
    золотоноша: 'Золотоніша',
    канев: 'Канів',
    // Київщина
    фастов: 'Фастів',
    васильков: 'Васильків',
    обухов: 'Обухів',
    вишневое: 'Вишневе',
    // Житомирщина
    бердичев: 'Бердичів',
    'новоград-волынский': 'Звягель',
    'новоград-волинський': 'Звягель',
    // Вінниччина
    'могилев-подольский': 'Могилів-Подільський',
    хмельник: 'Хмільник',
    казатин: 'Козятин',
    // Хмельниччина
    староконстантинов: 'Старокостянтинів',
    шепетовка: 'Шепетівка',
    // Тернопілля
    чортков: 'Чортків',
    кременец: 'Кременець',
    // Прикарпаття
    коломыя: 'Коломия',
    надворная: 'Надвірна',
    // Львівщина
    стрый: 'Стрий',
    трускавец: 'Трускавець',
    самбор: 'Самбір',
    червоноград: 'Шептицький',
    яворов: 'Яворів',
    броды: 'Броди',
    золочев: 'Золочів',
    // Рівненщина
    сарны: 'Сарни',
    // Волинь
    'владимир-волынский': 'Володимир',
    'владимир-волинський': 'Володимир',
    // Закарпаття
    виноградов: 'Виноградів',
    тячев: 'Тячів',
    рахов: 'Рахів',
    берегово: 'Берегове',
    // Буковина
    сторожинец: 'Сторожинець',
    // Одещина
    измаил: 'Ізмаїл',
    'белгород-днестровский': 'Білгород-Дністровський',
    черноморск: 'Чорноморськ',
    ильичевск: 'Чорноморськ',
    іллічівськ: 'Чорноморськ',
    южное: 'Південне',
    подольск: 'Подільськ',
    котовск: 'Подільськ',
    // Миколаївщина
    первомайск: 'Первомайськ',
    вознесенск: 'Вознесенськ',
    южноукраинск: 'Южноукраїнськ',
    очаков: 'Очаків',
    // Херсонщина
    'новая каховка': 'Нова Каховка',
    скадовск: 'Скадовськ',
    'голая пристань': 'Гола Пристань',
    // Сумщина
    охтырка: 'Охтирка',
    глухов: 'Глухів',
    // Чернігівщина
    нежин: 'Ніжин',
    // Крим
    керчь: 'Керч',
    феодосия: 'Феодосія',
    евпатория: 'Євпаторія',
};
// Автоканонізація: будь-яке написання назви зі списку (регістр, апостроф)
// зводиться до канонічного. Ручні аліаси мають пріоритет (значення ті самі).
const cityLookup = {};
for (const c of cities)
    cityLookup[cityKey(c.name)] = c.name;
Object.assign(cityLookup, cityAliases);
/**
 * Місто → канонічна українська назва зі списку `cities`. Приймає російські
 * написання («Черновцы»), історичні назви («Днепропетровск», «Червоноград»),
 * префікси «г.»/«м.» і рядки виду «Київ, Київська область». Невідомі
 * назви повертаються як є (обрізані) — це теж валідні місто-рядки оголошень.
 */
export function canonicalizeCity(name) {
    if (!name)
        return '';
    const cleaned = name.replace(/^\s*(?:г|м|гор|місто)\.\s*/i, '').replace(/\s+/g, ' ').trim();
    if (!cleaned)
        return '';
    const candidates = [cleaned];
    const comma = cleaned.indexOf(',');
    if (comma > 0)
        candidates.push(cleaned.slice(0, comma));
    for (const c of candidates) {
        const hit = cityLookup[cityKey(c)];
        if (hit)
            return hit;
    }
    return cleaned;
}
export function searchCities(query, limit = 20) {
    if (!query || query.length < 1)
        return cities.slice(0, limit);
    const q = query.toLowerCase().trim();
    return cities
        .filter((c) => c.name.toLowerCase().includes(q) || c.region.toLowerCase().includes(q))
        .slice(0, limit);
}
//# sourceMappingURL=cities.js.map